import { DeLeePlan, DeLeePlanMessages } from "@/enums/DeLeePlan";

import { PaginatedPartogramRecords } from "@/components/SurgicalCenter/SurgicalAttendance/OperatingRoom/MedicalSurgicalActView/PartogramFetusCharts";

type DilationAndDeLeeOptionsParams = {
	data: PaginatedPartogramRecords;
	xAxisCategories: Array<string | string[]>;
	dilation: Array<number | null>;
	deLeePlan: Array<number | null>;
};

export function dilationAndDeLeePlanOptions({
	data,
	xAxisCategories,
	dilation,
	deLeePlan,
}: DilationAndDeLeeOptionsParams) {
	return {
		options: {
			legend: {
				show: true,
				position: "top" as "top",
				showForSingleSeries: true,
				horizontalAlign: "left" as "left",
			},
			grid: {
				show: true,
				borderColor: "#5E6278",
				strokeDashArray: 3,
				row: {
					colors: ["transparent"],
				},
				column: {
					colors: ["transparent"],
				},
				xaxis: {
					lines: {
						show: true,
					},
				},
				padding: {
					top: 30,
				},
			},
			chart: {
				offsetX: 6,
				id: "dilation-line",
				toolbar: {
					show: false,
				},
			},
			stroke: {
				curve: "smooth" as "smooth",
				width: 2,
			},
			markers: {
				size: [10, 15],
				shape: ["circle", "square"],
				discrete: [
					{
						seriesIndex: 0,
						size: 10,
					},
					{
						seriesIndex: 1,
						size: 15,
					},
				],
			},
			xaxis: {
				position: "top",
				range: data.results?.length,
				tickPlacement: "between",
				labels: {
					offsetY: -15,
					style: {
						fontSize: "10px",
					},
				},
				categories: xAxisCategories,
			},
			yaxis: [
				{
					seriesName: "Dilatação/Cm",
					show: true,
					min: 0,
					max: 10,
					title: {
						text: "Dilatação/Cm",
						style: {
							fontSize: "16px",
							fontWeight: "600",
							fontFamily: "Inter, sans-serif",
						},
					},
					labels: {
						formatter(value: number) {
							if (value === 0) {
								return "";
							}

							return String(value);
						},
					},
				},
				{
					seriesName: "Plano de Lee",
					opposite: true,
					show: true,
					min: 0,
					max: 10,
					title: {
						text: "Plano de Lee",
						style: {
							fontSize: "16px",
							fontWeight: "600",
							fontFamily: "Inter, sans-serif",
						},
					},
					labels: {
						formatter(value: number) {
							const formattedValue =
								DeLeePlanMessages[String(value - 1) as DeLeePlan];

							if (Number(formattedValue) > 0) {
								return `+${formattedValue}`;
							}

							return formattedValue;
						},
					},
				},
			],
		},
		series: [
			{
				name: "Dilatação/Cm",
				data: dilation,
			},
			{
				name: "Plano de Lee",
				data: deLeePlan,
			},
		],
	};
}
